export const AGE_EXTRACT = {
    FILTER_CODE: '',
    KEY: 'ageExtract',
} as const;
export const AGING_CATEGORY = {
    FILTER_CODE: 'konyak_class',
    KEY: 'agingCategory',
} as const;
export const AGING_TANK = {
    FILTER_CODE: 'aging_tank',
    KEY: 'agingTank',
} as const;
export const APPELLATION = {
    FILTER_CODE: 'appellason',
    KEY: 'appellation',
} as const;
export const BARRELL = {
    FILTER_CODE: 'barrell',
    KEY: 'barrell',
} as const;
export const BRAND = {
    FILTER_CODE: 'manufacturer',
    KEY: 'manufacturer',
} as const;
export const CLASS = {
    FILTER_CODE: 'sake_class',
    KEY: 'class',
} as const;
export const COLOR = {
    FILTER_CODE: 'color',
    KEY: 'color',
} as const;
export const COUNTRY = {
    FILTER_CODE: 'country',
    KEY: 'country',
} as const;
export const DECANTATION = {
    FILTER_CODE: '',
    KEY: 'decantation',
} as const;
export const DRINK_CATEGORY = {
    FILTER_CODE: '',
    KEY: 'drinkCategory',
} as const;
export const DRINK_TYPE = {
    FILTER_CODE: 'drink_type',
    KEY: 'drinkType',
} as const;
export const FINE_RARE_ITEM = {
    FILTER_CODE: '',
    KEY: 'fineRareItem',
} as const;
export const GLASS_DIAMETER = {
    FILTER_CODE: '',
    KEY: 'glassDiameter',
} as const;
export const GLASS_HEIGHT = {
    FILTER_CODE: '',
    KEY: 'glassHeight',
} as const;
export const GRAPE_CONTENT = {
    FILTER_CODE: 'grape',
    KEY: 'grapeContent',
} as const;
export const MANUFACTURER = {
    FILTER_CODE: 'manufacturer',
    KEY: 'manufacturer',
} as const;
export const MATERIAL = {
    FILTER_CODE: 'material',
    KEY: 'material',
} as const;
export const NET_VOLUME = {
    FILTER_CODE: 'volume',
    KEY: 'netVolume',
} as const;
export const PREMIUM_PACK = {
    FILTER_CODE: '',
    KEY: 'premiumPack',
} as const;
export const PRODUCT_TYPE = {
    FILTER_CODE: 'product_type',
    KEY: 'productType',
} as const;
export const PRODUCTION_METHOD_HB = {
    FILTER_CODE: 'production_method',
    KEY: 'productionMethodHB',
} as const;
export const RAW = {
    FILTER_CODE: '',
    KEY: 'raw',
} as const;
export const REGION = {
    FILTER_CODE: 'region',
    KEY: 'region',
} as const;
export const RICE_AFTER_POLISHING = {
    FILTER_CODE: '',
    KEY: 'riceAfterPolishing',
} as const;
export const STORAGE_CAPACITY = {
    FILTER_CODE: '',
    KEY: 'storageCapacity',
} as const;
export const STRONGNESS = {
    FILTER_CODE: 'strength',
    KEY: 'strongness',
} as const;
export const SUGAR_TYPE = {
    FILTER_CODE: 'sugar_type',
    KEY: 'sugarType',
} as const;
export const SUITABLE = {
    FILTER_CODE: 'suitable',
    KEY: 'suitable',
} as const;
export const TEMPERATURE_FROM = {
    FILTER_CODE: '',
    KEY: 'temperatureFrom',
} as const;
export const TEMPERATURE_TO = {
    FILTER_CODE: '',
    KEY: 'temperatureTo',
} as const;
export const YEAR = {
    FILTER_CODE: 'year',
    KEY: 'year',
} as const;
export const ALCOHOL = {
    FILTER_CODE: 'alcohol',
    KEY: 'alcohol',
} as const;
export const CULTIVATION_TYPE = {
    FILTER_CODE: 'cultivationType',
    KEY: 'cultivationType',
};

const CHARACTERISTICS_LIST = [
    AGE_EXTRACT,
    AGING_CATEGORY,
    AGING_TANK,
    APPELLATION,
    BARRELL,
    BRAND,
    CLASS,
    COLOR,
    COUNTRY,
    DECANTATION,
    DRINK_CATEGORY,
    DRINK_TYPE,
    FINE_RARE_ITEM,
    GLASS_DIAMETER,
    GLASS_HEIGHT,
    GRAPE_CONTENT,
    MANUFACTURER,
    MATERIAL,
    NET_VOLUME,
    PREMIUM_PACK,
    PRODUCT_TYPE,
    PRODUCTION_METHOD_HB,
    RAW,
    REGION,
    RICE_AFTER_POLISHING,
    STORAGE_CAPACITY,
    STRONGNESS,
    SUGAR_TYPE,
    SUITABLE,
    TEMPERATURE_FROM,
    TEMPERATURE_TO,
    YEAR,
    ALCOHOL,
    CULTIVATION_TYPE,
] as const;

export type TCharacteristicKey = (typeof CHARACTERISTICS_LIST)[number]['KEY'] | string;
